import React from 'react';

interface PageControlProps {
  totalPages: number;
  currentPage: number;
  direction?: 'horizontal' | 'vertical';
  onPageChange: (page: number) => void;
  size?: 'xs' | 'sm' | 'md';
}

const PageControl = (props: PageControlProps) => {
  const {
    totalPages,
    currentPage,
    onPageChange,
    direction = 'horizontal',
    size = 'md',
  } = props;

  const activeClass = '!bg-primary-500';

  const sizeClasses = {
    xs: 'w-1 h-1',
    sm: 'w-[0.375rem] h-[0.375rem]',
    md: 'w-2 h-2',
  };

  const baseClass = `bg-primary-200 rounded-full cursor-pointer duration-200 ${sizeClasses[size]}`;

  const directionClasses = {
    horizontal: 'flex items-center justify-center gap-2',
    vertical: 'flex flex-col items-center justify-center gap-2',
  };

  return (
    <div
      className={`${directionClasses[direction]} px-3 py-2 rounded-full bg-gray-50 w-fit`}
    >
      {Array.from({ length: totalPages }).map((_, index) => (
        <button
          className={`${baseClass} ${currentPage === index + 1 ? activeClass : ''}`}
          key={index}
          onClick={() => onPageChange(index + 1)}
        />
      ))}
    </div>
  );
};

export default PageControl;
